
import React from 'react';
import Layout from '../components/Layout';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const TermsAndPolicy = () => {
  const navigate = useNavigate();
  
  return (
    <Layout>
      <div className="pt-32 pb-16 bg-gradient-to-b from-primary to-primary-dark">
        <div className="container mx-auto px-4">
          <Button 
            variant="ghost" 
            className="text-white mb-4 hover:bg-white/10" 
            onClick={() => navigate('/')}
          >
            <ArrowLeft className="mr-2 h-4 w-4" />
            Voltar para página inicial
          </Button>
          <h1 className="text-3xl md:text-4xl font-bold text-white mb-6">
            Termos de Uso e Política de Privacidade
          </h1>
        </div>
      </div>
      
      <div className="container mx-auto px-4 py-12">
        <div className="max-w-4xl mx-auto">
          <section className="mb-12 reveal">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Termos de Uso</h2>
            <div className="prose max-w-none">
              <p>Bem-vindo aos Termos de Uso do Método PPS. Ao acessar ou utilizar nosso site e adquirir nossos cursos, você concorda com os termos e condições descritos abaixo.</p>
              
              <h3 className="text-xl font-semibold mt-6 mb-3">1. Aceitação dos Termos</h3>
              <p>Ao acessar e utilizar este site, você confirma que leu, entendeu e concorda com estes Termos de Uso. Se você não concordar com qualquer parte destes termos, solicitamos que não utilize nossos serviços.</p>
              
              <h3 className="text-xl font-semibold mt-6 mb-3">2. Descrição do Serviço</h3>
              <p>O Método PPS oferece cursos online sobre amamentação e cuidados com bebês. Nossos conteúdos são disponibilizados após confirmação de pagamento e incluem acesso a vídeos, materiais didáticos e bônus descritos em nossa página de vendas.</p>
              
              <h3 className="text-xl font-semibold mt-6 mb-3">3. Cadastro e Informações da Conta</h3>
              <p>Para acessar nossos cursos, é necessário criar uma conta com informações precisas e completas. Você é responsável por manter a confidencialidade de sua senha e por todas as atividades realizadas em sua conta.</p>
              
              <h3 className="text-xl font-semibold mt-6 mb-3">4. Propriedade Intelectual</h3>
              <p>Todo o conteúdo disponibilizado em nosso site e cursos, incluindo textos, gráficos, logos, ícones, imagens, clipes de áudio, downloads digitais e compilações de dados, é propriedade do Método PPS e está protegido por leis de direitos autorais. É estritamente proibida a reprodução, distribuição ou utilização destes materiais sem autorização expressa.</p>
              
              <h3 className="text-xl font-semibold mt-6 mb-3">5. Política de Reembolso</h3>
              <p>Oferecemos garantia de satisfação de 15 dias a partir da data de compra. Caso não esteja satisfeito com o curso, você pode solicitar o reembolso integral dentro deste período, sem necessidade de justificativa.</p>
              
              <h3 className="text-xl font-semibold mt-6 mb-3">6. Limitações de Responsabilidade</h3>
              <p>As informações fornecidas em nossos cursos são para fins educacionais e não substituem o aconselhamento médico profissional. Não nos responsabilizamos por decisões tomadas com base em nosso conteúdo sem consulta a profissionais de saúde.</p>
              
              <h3 className="text-xl font-semibold mt-6 mb-3">7. Modificações dos Termos</h3>
              <p>Reservamo-nos o direito de modificar estes termos a qualquer momento. As modificações entrarão em vigor imediatamente após sua publicação no site. É sua responsabilidade verificar regularmente estes termos para estar ciente de quaisquer alterações.</p>
            </div>
          </section>
          
          <section className="reveal">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Política de Privacidade</h2>
            <div className="prose max-w-none">
              <p>A proteção de seus dados pessoais é importante para nós. Esta Política de Privacidade explica como coletamos, usamos e protegemos suas informações quando você utiliza nosso site e serviços.</p>
              
              <h3 className="text-xl font-semibold mt-6 mb-3">1. Coleta de Informações</h3>
              <p>Coletamos informações que você nos fornece diretamente, como nome, endereço de e-mail, telefone e informações de pagamento ao se cadastrar em nosso site ou adquirir nossos cursos.</p>
              
              <h3 className="text-xl font-semibold mt-6 mb-3">2. Uso das Informações</h3>
              <p>Utilizamos suas informações para:</p>
              <ul className="list-disc pl-6 mb-4">
                <li>Processar transações e fornecer acesso aos cursos adquiridos</li>
                <li>Enviar comunicações relacionadas ao serviço</li>
                <li>Fornecer suporte ao cliente</li>
                <li>Melhorar nossos produtos e serviços</li>
                <li>Enviar materiais promocionais e newsletters (com seu consentimento)</li>
              </ul>
              
              <h3 className="text-xl font-semibold mt-6 mb-3">3. Compartilhamento de Informações</h3>
              <p>Não vendemos, comercializamos ou transferimos suas informações pessoais para terceiros, exceto para prestadores de serviços que nos ajudam a operar nosso site e conduzir nossos negócios (como processadores de pagamento e plataformas de hospedagem de cursos).</p>
              
              <h3 className="text-xl font-semibold mt-6 mb-3">4. Segurança</h3>
              <p>Implementamos medidas de segurança para proteger suas informações pessoais contra acesso não autorizado, alteração, divulgação ou destruição. No entanto, nenhuma transmissão pela internet ou armazenamento eletrônico é 100% seguro, e não podemos garantir segurança absoluta.</p>
              
              <h3 className="text-xl font-semibold mt-6 mb-3">5. Cookies e Tecnologias Semelhantes</h3>
              <p>Utilizamos cookies e tecnologias semelhantes para melhorar sua experiência em nosso site, entender como você interage com nosso conteúdo e oferecer publicidade personalizada.</p>
              
              <h3 className="text-xl font-semibold mt-6 mb-3">6. Seus Direitos</h3>
              <p>Você tem o direito de acessar, corrigir ou excluir suas informações pessoais a qualquer momento. Também pode optar por não receber comunicações de marketing enviando um e-mail para o nosso contato de suporte.</p>
              
              <h3 className="text-xl font-semibold mt-6 mb-3">7. Alterações na Política de Privacidade</h3>
              <p>Podemos atualizar esta política periodicamente. Informaremos sobre alterações significativas através de aviso em nosso site ou por e-mail.</p>
              
              <h3 className="text-xl font-semibold mt-6 mb-3">8. Contato</h3>
              <p>Se você tiver dúvidas sobre esta Política de Privacidade ou sobre como tratamos seus dados, entre em contato conosco através do e-mail: contato@metodopps.com.br</p>
            </div>
          </section>
        </div>
      </div>
    </Layout>
  );
};

export default TermsAndPolicy;
